function initSkipMap(skips) {

  var mapDiv = document.getElementById("skip-map");  
  if (!mapDiv) {
  	return;
  }
  
  var map = new google.maps.Map(mapDiv, {
	center: {lat: -27.5788, lng: 153.026},
	zoom: 10,
   	zoomControl: true         
  });  
 
  
  skips.forEach(skip => {
    var endofAddress = skip.description.indexOf("</p>");
    //var latLng = skip.description.charAt(startofAddress);
    
    //var test[] = skip.description.split("</p>",2);
    //var test2 = test[0];
    var latLng = skip.description.replace("<p>","").replace("</p>","").replace("lat", '"lat"').replace("lng", '"lng"').replace("<span>","").replace("</span>","");    
    if (skip.description == "") {latLng = "{\"lat\": 0,\"lng\": 0}"};
    
    var latLng = JSON.parse(latLng);   
    var skipLocation = {name:  "Skip available for collection here", ...latLng};  // "Skip available for collection here"
    createSkipMarker(skipLocation);    
  });
 
  //var imageUrl = "https://cdn.shopify.com/s/files/1/1665/6197/files/Google_M_icon.png?1017007359068392630";
    
  function createSkipMarker(skipLocation) {
    return new google.maps.Marker({
      position: new google.maps.LatLng(skipLocation.lat, skipLocation.lng),  
      animation: google.maps.Animation.DROP,
      title: skipLocation.name,  
      label: 'S',
      //icon: imageUrl,
      map: map
    });
  }
  
      new google.maps.Marker({
    	position: new google.maps.LatLng(-27.578829, 153.026233),  
    	animation: google.maps.Animation.DROP,
     	title: 'Collect a skip from the Mega Hire Branch - 1206 Beaudesert Rd, Acacia Ridge',
     	label: 'M',
      	//icon: imageUrl,
    	map: map
    });
	
// 	var zone1 = new google.maps.Polygon({
// 		paths: [zone1Coords],
// 		strokeColor: "#000000",
// 		strokeOpacity: 0.2,
// 		strokeWeight: 1,
// 		fillColor: "#cc0000",		 
// 		fillOpacity: 0.13,			
// 		id: 1,		 
// 	});
	
// 	var zone2 = new google.maps.Polygon({
// 		paths: [zone2Coords],
// 		strokeColor: "#000000",
// 		strokeOpacity: 0.2,
// 		strokeWeight: 1,
// 		fillColor: "#ff8800",
// 		fillOpacity: 0.13,			
// 		id: 2,			 
// 	});
	
// 	var zone3 = new google.maps.Polygon({
// 		paths: [zone3aCoords, zone3bCoords],
// 		strokeColor: "#000000",
// 		strokeOpacity: 0.2,
// 		strokeWeight: 1,
// 		fillColor: "#007e33",
// 		fillOpacity: 0.13,		
// 		id: 3,		
// 	});
	
// 	var zone4 = new google.maps.Polygon({
// 		paths: [zone4aCoords, zone4bCoords, zone4cCoords],
// 		strokeColor: "#000000",
// 		strokeOpacity: 0.2,
// 		strokeWeight: 1,		
// 		fillColor: "#304ffe",
// 		fillOpacity: 0.13,		
// 		id: 4,		
// 	});
	
//   	var zone5 = new google.maps.Polygon({
// 		paths: [zonePOACoords],
// 		strokeColor: "#000000",
// 		strokeOpacity: 0.2,
// 		strokeWeight: 1,		
// 		fillColor: "#FF6A00",
// 		fillOpacity: 0.11,		
// 		id: "POA (call 1300 546 122)",		
// 	});
	
// 	addZoneEventListeners(zone1);	
// 	addZoneEventListeners(zone2);
// 	addZoneEventListeners(zone3);
// 	addZoneEventListeners(zone4);
// 	addZoneEventListeners(zone5);
	
// 	function addZoneEventListeners(zone) {
// 		zone.setMap(map);
// 		var zoneInfo = document.getElementById("skip-info");
				
// 		google.maps.event.addListener(zone, "mouseover", function(event) {		
// 			zone.setOptions({fillOpacity: 0.3, strokeWeight: 2, strokeOpacity: 0.4});		
// 			toggleVisibility(zone, zoneInfo, "visible");
// 		});
		
// 		google.maps.event.addListener(zone, "mouseout", function(event) {
// 			zone.setOptions({fillOpacity: 0.13, strokeWeight: 1, strokeOpacity: 0.15});
// 			toggleVisibility(zone, zoneInfo, "hidden");
// 		});  
// 	}		
	
// 	function toggleVisibility(zone, zoneInfo, visibility) {
// 		zoneInfo.style.visibility = visibility;	
// 		if (visibility == "visible") {

//               document.getElementById("skip-info-name").innerText = "Delivery Zone: " + zone.id;
//               zoneInfo.style.backgroundColor = zone.fillColor;
//               zoneInfo.style.opacity = 1;
            
// 		} else {
// 			zoneInfo.style.opacity = 0;
// 		}
// 	}
  
  
  // Create the search box and link it to the UI element.
	var input = document.getElementById("skipmap-search-box");
	var searchBox = new google.maps.places.SearchBox(input);
	map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

	// Bias the SearchBox results towards current map's viewport.
	map.addListener("bounds_changed", function() {
		searchBox.setBounds(map.getBounds());
	});

	var markers = [];
	
	// Listen for the event fired when the user selects a prediction and retrieve
	// more details for that place.
	searchBox.addListener('places_changed', function() {
		var places = searchBox.getPlaces();

		if (places.length == 0) {
			return;
		}

		// Clear out the old markers.
		markers.forEach(function(marker) {
			marker.setMap(null);
		});
		markers = [];

		// For each place, get the icon, name and location.
		var bounds = new google.maps.LatLngBounds();
		places.forEach(function(place) {
			if (!place.geometry) {				
				return;
			}
			
			var icon = {
				url: place.icon,
				size: new google.maps.Size(71, 71),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(17, 34),
				scaledSize: new google.maps.Size(25, 25)
			};

			// Create a marker for each place.
			markers.push(new google.maps.Marker({
				map: map,
				icon: icon,
				title: place.name,
				position: place.geometry.location
			}));

			if (place.geometry.viewport) {
			  // Only geocodes have viewport.
			  bounds.union(place.geometry.viewport);
			} else {
			  bounds.extend(place.geometry.location);
			}
	  });
	  
	  map.fitBounds(bounds);
	});  
  
}